import { CheckSquareFilled } from "@ant-design/icons";
import React, { FC } from "react";
import "./checkboxComponent.scss";
interface CheckboxGroupProps {
  value?: string;
  checked?: boolean;
}
interface CheckboxComponentProps {
  title?: string;
  value?: string;
  data?: CheckboxGroupProps[];
  onChange?: (value: any) => void;
  group?: boolean;
  checked?: boolean;
}
interface CheckboxCustomProps {
  value: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}
const CheckboxCustom: FC<CheckboxCustomProps> = ({
  value,
  checked,
  onChange,
}) => {
  return (
    <div className="checkbox__custom">
      <p className="checkbox-custom__value">{value}</p>
      <div onClick={() => onChange(!checked)}>
        {!checked ? (
          <div className="checkbox__uncheck"></div>
        ) : (
          <CheckSquareFilled className="checkbox__check" />
        )}
      </div>
    </div>
  );
};
const CheckboxComponent: FC<CheckboxComponentProps> = ({
  group = false,
  title,
  data,
  onChange,
  checked,
  value,
}) => {
  return group ? (
    <div className="checkbox__group">
      <p className="checkbox-group__title">{title}</p>
      {data?.map((item, index) => {
        return (
          <CheckboxCustom
            key={"CHECK#" + index}
            onChange={() => onChange && onChange(index)}
            value={item.value ?? ""}
            checked={item.checked ?? false}
          />
        );
      })}
    </div>
  ) : (
    <div>
      <CheckboxCustom
        onChange={(value) => onChange && onChange(value)}
        value={value ?? ""}
        checked={checked ?? false}
      />
    </div>
  );
};
export default CheckboxComponent;
